<template>

    <div>

        <configure-property :label="$t('configurationProperty.galleryImage')">

            <div v-if="existingGalleries.length" class="configure-property">
                <div class="select" style="margin-bottom: 5px;">
                    <select @change="eventGalleryIdModified" name="" id="">
                        <option v-for="gallery in existingGalleries" :value="gallery.id">{{ gallery.name }}</option>
                    </select>
                </div>
            </div>

            <div v-if="data.getImageIsManipulable()" class="file-upload">

                <div class="image-gallery">
                    <img v-for="image in galleryImages" :src="image.src" @click="chooseImageFromGallery(image.id)" alt="">
                </div>

            </div>

        </configure-property>

    </div>

    <!-- <div class="print-elements">

        <label>
            Höhe
            <input type="number" :value="data.getScaledHeight()" @input="eventHeightModified">
        </label>

        <label>
            Breite
            <input type="number" :value="data.getScaledWidth()" @input="eventWidthModified">
        </label>

        <label>
            Drehen
            <input type="number" :value="data.getAngle()" @input="eventAngleModified">
        </label>

    </div> -->

</template>

<script>
    import requestHelper from "./../../api/requestHelper";
    import ImageCanvasObject from "./ImageCanvasObject";

    export default {
        name: "ImageGalleryCanvasObject",
        extends: ImageCanvasObject,
        data: () => ({
            choosenImage: null,
            mimeTypesNeedUploadFirst: [ 'application/postscript', 'application/pdf' ],
            fileExtensionsNeedUploadFirst: [ 'ai', 'eps', 'pdf' ],
            directUseMimeTypes: [ 'image/png', 'image/jpeg' ],
            existingGalleries: [],
            gallery: {}
        }),
        props: {
            data: {
                type: Object,
                default: () => ({})
            }
        },
        computed: {
            galleryImages() {

                if (this.gallery.hasOwnProperty('images')) {
                    return this.gallery.images.map(image => {

                        return {
                            id: image.id,
                            src: requestHelper.createUrl(`/image/${image.id}`),
                            filename: image.filename
                        };

                    });
                }

            }
        },
        methods: {
            async eventGalleryIdModified(e) {
                this.data.setGalleryId( parseFloat(e.target.value) );
                await this.loadGalleryImages();
                this.data.getCanvas().render();
            },
            async chooseImageFromGallery(imageId) {

                const image = this.gallery.images.find(image => image.id == imageId);

                if (!image) {
                    return;
                }

                this.data.setImageUrl(
                    requestHelper.createUrl(`/image/${imageId}`)
                );

                this.data.setFilename(image.filename);

                await this.data.createImageStore();

                this.data.getCanvas().render();

            },
            async loadGalleryImages() {
                if (this.data.getGalleryId()) {

                    this.gallery = await requestHelper.requestApiRoute('get', `/imagegallery/${this.data.getGalleryId()}`);

                    if (this.gallery.images.length) {

                        if (this.data.getImageUrl() === null && this.data.getImageContent() === null) {
                            this.data.allowResizing();
                            await this.chooseImageFromGallery(this.gallery.images[0].id);
                        }
                    } else {
                        this.data.setImageUrl('img/default2.png');
                    }

                }
            },
            async mounted() {

                if (window['w2p_admin'] === true) {

                    this.existingGalleries = [
                        {
                            id: null,
                            name: 'Bitte eine Galerie auswählen...'
                        }
                    ].concat(await requestHelper.requestApiRoute('get', '/imagegallery'));

                }

                this.loadGalleryImages();

            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/var";

    h4 {
        color: $blue-color;
        margin: 0;
        margin-bottom: 10px;
    }

    .print-elements {
        background-color: #ffffff;
        margin-bottom: 10px;
        padding: 10px;
    }

    .print-elements strong {
        color: #004B92;
        font-weight: normal;
    }

    .file-upload {

        width: 100%;
        display: flex;
        flex-direction: column;
        border-radius: 5px;

        input {
            display: none;
        }

        label {
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background-color: lighten($grey-font, 50);
            color: $grey-font;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;

            &:hover {
                cursor: pointer;
                background-color: lighten($grey-font, 40);
            }
        }

        div.filename {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #ffffff;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }

    }

    .image-preview {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        background-color: white;
        margin: 2rem 0;

        img {
            padding: 20px 0;
            max-width: 70%;
            max-height: 200px;
        }
    }

    label.configure-property {
        display: flex;
        flex-direction: column;
        margin-bottom: .5rem;

        span {
            color: $blue-color;
            font-weight: lighter;
        }

        input {
            box-sizing: border-box;
            border-radius: 5px;
            width: 100%;
            border: 1px solid $grey-font;
            background-color: white;
            padding: 0.5rem;

            &:invalid {
                border: 1px solid $grey-font;
                box-shadow: none;
            }
        }
    }

    .image-gallery {
        display: flex;

        img {
            margin: 0 5px 5px 0;
            max-width: 50px;
            max-height: 50px;
        }
    }

    .select {
        box-sizing: border-box;
        width: 100%;
        border: 1px solid $grey-font;
        border-radius: 5px;
        position: relative;
        background-color: #ffffff;

        select {
            font-size: 0.8rem;
            border-radius: 5px;
            margin: 0;
            padding: 0.6rem 2rem 0.6rem 0.4rem;
            border: 0;
            box-sizing: border-box;
            width: 100%;
            -webkit-appearance: none;
            -moz-appearance: none;

            &::-ms-expand {
                display: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        &::after {
            position: absolute;
            font-family: "Material Icons";
            content: "arrow_drop_down";
            top: 50%;
            margin-top: -.5rem;
            right: .5rem;
            width: 1rem;
            height: 1rem;
            color: $blue-color;
            font-size: 1rem;
        }
    }

</style>